module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IApproachingExpirationAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class InventoryProductLotApproachingExpirationConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public inventoryProductLotDaysBeforeExpiration: number = 30;
        public daysOptions: number[] = [30, 60, 90, 120, 180];

        public selectedItems: any[] = [];
        public isAllSelected: boolean = true;

        public readonly dataForReviewTemplate: string;

        private categoryNameMap: { [id: string]: string } = {};

        // Stable references to avoid AngularJS infdig in ng-repeat
        private _dataForReviewRow: { settings: string[]; categories: string[] } = { settings: [], categories: [] };
        private _dataForReview: { settings: string[]; categories: string[] }[] = [];
        private _alertConfiguration: { [key: string]: any } = {};

        get dataForReview() {
            // BaseConfigComponent.$onInit/$onDestroy resets the array via .length = 0.
            // Re-attach our row each digest so ng-repeat keeps rendering.
            if (this._dataForReview.length === 0) {
                this._dataForReview.push(this._dataForReviewRow);
            }

            const daysLabel = `${this.$translate.instant('LABEL_ALERT_INVENTORY_PRODUCT_LOT_DAYS_BEFORE_EXPIRATION')} ${this.inventoryProductLotDaysBeforeExpiration}`;

            // Mutate settings array in place
            this._dataForReviewRow.settings.length = 0;
            this._dataForReviewRow.settings.push(daysLabel);

            // Mutate categories array in place
            this._dataForReviewRow.categories.length = 0;
            if (this.isAllSelected) {
                this._dataForReviewRow.categories.push(this.$translate.instant('LABEL_ALL_PRODUCT_CATEGORIES'));
            } else {
                for (const id of (this.selectedItems || [])) {
                    const name = this.categoryNameMap[id];
                    // While categories are still loading, fall back to id so the row
                    // is non-empty (ng-show > 0) and names appear once loadCategories resolves.
                    this._dataForReviewRow.categories.push(name || id);
                }
            }

            return this._dataForReview;
        }

        get alertConfiguration() {
            this._alertConfiguration[this.data.configKey] = this.inventoryProductLotDaysBeforeExpiration;
            this._alertConfiguration['productCategories'] = (this.selectedItems || []).map((item) => item.id || item);
            this._alertConfiguration['allProductCategories'] = this.isAllSelected;
            return this._alertConfiguration;
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private identityService: Meevo.Components.Common.IIdentityService) {
            super(alertsManagerService);
            this.dataForReviewTemplate = 'app/plugins/alertsManager/addNewAlert/config-components/inventory-product-lot-approaching-expiration-config/inventory-product-lot-approaching-expiration-review.html';
        }

        $onInit() {
            super.$onInit();
            this.loadCategories();
        }

        onEdit(alertJSON: IApproachingExpirationAlertJson): void {
            if (alertJSON[this.data.configKey]) {
                this.inventoryProductLotDaysBeforeExpiration = alertJSON[this.data.configKey];
            }
            const categories = alertJSON['productCategories'] || [];
            this.selectedItems.length = 0;
            this.selectedItems.push(...categories);

            if (angular.isDefined(alertJSON['allProductCategories'])) {
                this.isAllSelected = alertJSON['allProductCategories'];
            }
        }

        private loadCategories(): void {
            this.dataService.getListPaged('productCategory', {
                criteria: {
                    businessTypeList: [this.identityService.businessTypeId],
                    locationList: [this.identityService.locationId],
                    objectStateEnumList: [1],
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                },
                itemsPerPage: 50000
            }).then((categories: any[]) => {
                for (const cat of (categories || [])) {
                    this.categoryNameMap[cat.id] = cat.displayName;
                }
            });
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoInventoryProductLotApproachingExpirationConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/inventory-product-lot-approaching-expiration-config/inventory-product-lot-approaching-expiration-config.component.html',
            controller: InventoryProductLotApproachingExpirationConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}